import * as React from 'react';
import InputComponent from './InputComponent';
import Nations from './countries';

interface INameState {
    hasError: boolean
    nameValue: string
}

interface INameProps {
    id?: string
    content: any
    validateInput(inputID: string, isCorrect: boolean): any,
    onValueChange(value: string): void
    countryInputValue(value: string): void
}


class CountrySuggestionInput extends React.Component<INameProps, INameState> {

    constructor(props: INameProps) {
        super(props);
        this.state = {
            hasError: false,
            nameValue: '',
        }

        this.handleError = this.handleError.bind(this)
        this.changeInputValue = this.changeInputValue.bind(this)
        this.validateNameInput = this.validateNameInput.bind(this)
        this.preventSpecificKeys = this.preventSpecificKeys.bind(this)
    }
    public componentDidMount(): void {
      const Countries = Nations.map(nation => nation.name)
      if(document.getElementById('CountryInput')) {
        this.autocomplete(document.getElementById('CountryInput'), Countries);
      }
    }
    public autocomplete(inp: any, arr: string[]) {
      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      let currentFocus: any;
      const closeAllLists = (elmnt?: any): void  => {
        /*close all autocomplete lists in the document, 
        except the one passed as an argument:*/
        const x: any = document.getElementsByClassName('autocomplete-items');
        for (const i of x) {
          if (elmnt !== i && elmnt !== inp) {
            i.parentNode.removeChild(i);
          }
        }
      }
      /*execute a function when someone writes in the text field:*/
      const countryInputValue = (inputValue: string) => {
        this.props.countryInputValue(inputValue)
      }
      const handler = (e: any): void | false => {
        let a;
        let b;
        const val = e.target.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        
        if (!val) { return false;}
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement('DIV');
        a.setAttribute('id', e.target.id + 'autocomplete-list');
        a.setAttribute('class', 'autocomplete-items');
        /*append the DIV element as a child of the autocomplete container:*/
        e.target.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (const country of arr) {
          /*check if the item starts with the same letters as the text field value:*/
          if (country.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
            /*create a DIV element for each matching element:*/
            b = document.createElement('DIV');
            /*make the matching letters bold:*/
            b.innerHTML = '<strong>' + country.substr(0, val.length) + '</strong>';
            b.innerHTML += country.substr(val.length);
            /*insert a input field that will hold the current array item's value:*/
            b.innerHTML += `<input type='hidden' value='${country}'>`;
            /*execute a function when someone clicks on the item value (DIV element):*/
            b.addEventListener('click', function(){
                /*insert the value for the autocomplete text field:*/
                inp.value = this.getElementsByTagName('input')[0].value;
                const counryCode = Nations.filter(nation => nation.name === inp.value)
                if (counryCode.length > 0) {
                  countryInputValue(counryCode[0].code.toLocaleLowerCase())
                }
                /*close the list of autocompleted values,
                (or any other open lists of autocompleted values:*/
                closeAllLists();
            });
            a.appendChild(b);
          }
        }
      }
      const handlerCountryChange = (e: any) => {
        handler(e)
      }
      
      inp && inp.addEventListener('input', handlerCountryChange);
      
      /*execute a function presses a key on the keyboard:*/
      inp && inp.addEventListener('keydown', (e: any) => {
          let x: any = document.getElementById(e.target.id + 'autocomplete-list');
          if (x) {
            x = x.getElementsByTagName('div');
          }
          if (e.keyCode === 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode === 38) { // up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode === 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) {
                x[currentFocus].click();
              }
            }
          }
      });
      function addActive(x: any): void | false {
        /*a function to classify an item as "active":*/
        if (!x) {
          return false;
        }
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) {
          currentFocus = 0;
        }
        if (currentFocus < 0) {
          currentFocus = (x.length - 1);
        }
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add('autocomplete-active');
      }
      function removeActive(x: any) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (const i of x) {
          i.classList.remove('autocomplete-active');
        }
      }
      
      /*execute a function when someone clicks in the document:*/
      document.addEventListener('click', (e) => {
          closeAllLists(e.target);
      });
    }
    public changeInputValue(input: string): void {
        this.setState({
            nameValue: input
        }, () => {
            if (this.state.hasError) {
                this.handleError()
            } else {
                this.validateNameInput()
            }

            this.props.onValueChange(input);
        })
        
    }
    public handleError(): void {
        if (this.state.nameValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validateNameInput()
            })
        } else if (!this.state.nameValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validateNameInput()
            })
        } else {
            this.setState({
                hasError: true
            })
        }
    }

    public validateNameInput(): void {
        if (!this.state.hasError && this.state.nameValue.length) {
            this.props.validateInput('country', true)
        } else {
            this.props.validateInput('country', false)
        }
    }

    public preventSpecificKeys(e: React.KeyboardEvent): any {
        const nameRegex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\s'-]+$/;
        if (!nameRegex.test(e.key)) {
            e.preventDefault()
            return false
        }
        return true
    }


    public render() {
        if (this.props.content === null) {
            return null
        }

        return (
            <InputComponent
                id={this.props.id}
                inputValue={this.state.nameValue}
                hasError={this.state.hasError}
                placeholder={this.props.content.countryInputLabel}
                errorMessage={this.props.content.country_input_error
                }
                maxLength={100}
                changeInputValue={this.changeInputValue}
                checkInput={this.handleError}
                preventSpecificKeys={this.preventSpecificKeys} />
        )
    }
}

export default CountrySuggestionInput





// WEBPACK FOOTER //
// ./src/components/Inputs/CountrySuggestionInput.tsx